module.exports = __webpack_public_path__ + "static/img/40014 (2).796b0f3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40014 (2).webp
// module id = 2l4D
// module chunks = 14